import axios from 'axios';
import { TUserParamsSearch, TStaffSearch } from '../components/ui/UsersFilter/types';
import {
  CREATE_USER_URL,
  getUserUrl,
  SEND_INVITE_URL,
  delUserUrl,
} from '../constants';
import { IUserAddProps } from '../interfaces/user';

export function getUsersByRole(params: TUserParamsSearch) {
  let url = `/api/users/search`;
  let { filter } = params;

  if (Object.keys(filter).length > 0) {
    for (const key of Object.keys(filter)) {
      if (filter[key].length > 0) {
        url += `&${key}=${filter[key].join(',')}`;
      }
    }
  }

  return axios.get(url, {
    params: {
      ...params,
    },
  });
}

export function getSearchUsers(params: Partial<TStaffSearch>) {
  let url = `/api/users/search`;
  return axios.get(url, { params });
}

export function getUser(id: number) {
  return axios.get(getUserUrl(id));
}

export function createUser(data: IUserAddProps) {
  return axios.post(CREATE_USER_URL, data);
}

export function editUser(id: number, data: any) {
  return axios.put(`/api/user/${id}/edit`, data);
}

export function sendInvite(data: string) {
  return axios.get(`${SEND_INVITE_URL}`, { params: { email: data } });
}

export function delUser(id: number) {
  return axios.delete(delUserUrl(id));
}

export const editManagerRole = (
  manager_id: number,
  role: 'ROLE_VENDOR' | 'ROLE_VENDOR_STAFF' | 'ROLE_BUYER' | 'ROLE_BUYER_STAFF'
) => axios.put(`/api/companies/manager/${manager_id}`, {}, { params: { role } });
